import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollReveal from "./components/ScrollReveal";

import Home from "./pages/Home";
import SafetyCenter from "./pages/SafetyCenter";
import ConversationCoach from "./pages/ConversationCoach";
import InstafrndCeleb from "./pages/InstafrndCeleb";
import CelebConnectForm from "./pages/CelebConnectForm";
import Privacy from "./pages/Privacy";
import ChildSafety from "./pages/ChildSafety";
import Contact from "./pages/Contact";
import DeleteAccount from "./pages/DeleteAccount";
import NotFound from "./pages/NotFound";

// Scrolls to top on every route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <ScrollReveal />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/safety" element={<SafetyCenter />} />
          <Route path="/become-a-coach" element={<ConversationCoach />} />
          <Route path="/become-celeb" element={<InstafrndCeleb />} />
          <Route path="/celeb-connect" element={<CelebConnectForm />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/child-safety" element={<ChildSafety />} />
          <Route path="/contact" element={<Contact />} />
          {/* Account deletion — intentionally not linked in the nav (hidden URL). */}
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
